import { FC, ReactNode, useEffect } from "react";
interface DetailTableTRProps {
    className: any;
    children: ReactNode | string;
    colSpan?: number;
}

const DetailTableTD: FC<DetailTableTRProps> = ({ className, children, colSpan = 2 }) => {

    return (
        <>
            <td className={className} colSpan={colSpan}>
                {children}
            </td>
        </>
    )
}

export default DetailTableTD;